import React, { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    nom: '',
    email: '',
    sujet: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    // Simuler l'envoi du message
    setTimeout(() => {
      setLoading(false);
      setSuccess(true);
      setFormData({ nom: '', email: '', sujet: '', message: '' });
    }, 1000);
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-12">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-display font-bold text-gray-900 dark:text-primary-300 mb-4">
            Contactez-nous
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-400">
            Nous sommes là pour vous aider et répondre à vos questions
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Informations de contact */}
          <div className="lg:col-span-1">
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-8 h-fit">
              <h2 className="text-2xl font-display font-bold text-gray-900 dark:text-primary-300 mb-6">
                Nos Coordonnées
              </h2>
              
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-primary-100 dark:bg-primary-900/40 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="fas fa-map-marker-alt text-primary-800 dark:text-primary-400"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 dark:text-gray-200 mb-1">Adresse</h3>
                    <p className="text-gray-600 dark:text-gray-400">
                      Dakar, Sénégal<br />
                      Plateau - Centre-ville
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-primary-100 dark:bg-primary-900/40 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="fas fa-phone text-primary-800 dark:text-primary-400"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 dark:text-gray-200 mb-1">Téléphone</h3>
                    <p className="text-gray-600 dark:text-gray-400">+221 77 798 03 26</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-primary-100 dark:bg-primary-900/40 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="fas fa-envelope text-primary-800 dark:text-primary-400"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 dark:text-gray-200 mb-1">Email</h3>
                    <p className="text-gray-600 dark:text-gray-400">contact@villageartisanal.sn</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-primary-100 dark:bg-primary-900/40 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="fab fa-whatsapp text-primary-800 dark:text-primary-400"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 dark:text-gray-200 mb-1">WhatsApp</h3>
                    <p className="text-gray-600 dark:text-gray-400">+221 77 931 78 65</p>
                  </div>
                </div>
              </div>

              <div className="mt-8 pt-6 border-t border-gray-200 dark:border-gray-700">
                <h3 className="font-semibold text-gray-900 dark:text-gray-200 mb-4">Suivez-nous</h3>
                <div className="flex space-x-4">
                  <button className="w-10 h-10 bg-blue-600 text-white rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors">
                    <i className="fab fa-facebook-f"></i>
                  </button>
                  <button className="w-10 h-10 bg-pink-600 text-white rounded-full flex items-center justify-center hover:bg-pink-700 transition-colors">
                    <i className="fab fa-instagram"></i>
                  </button>
                  <button className="w-10 h-10 bg-blue-400 text-white rounded-full flex items-center justify-center hover:bg-blue-500 transition-colors">
                    <i className="fab fa-twitter"></i>
                  </button>
                  <button className="w-10 h-10 bg-blue-800 text-white rounded-full flex items-center justify-center hover:bg-blue-900 transition-colors">
                    <i className="fab fa-linkedin-in"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Formulaire de contact */}
          <div className="lg:col-span-2">
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-8">
              <h2 className="text-2xl font-display font-bold text-gray-900 dark:text-primary-300 mb-6">
                Envoyez-nous un message
              </h2>

              {success && (
                <div className="bg-green-100 dark:bg-green-900/30 border border-green-400 dark:border-green-700 text-green-700 dark:text-green-300 px-4 py-3 rounded mb-6">
                  Votre message a été envoyé avec succès ! Nous vous répondrons bientôt.
                </div>
              )}

              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="nom" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Nom complet *
                    </label>
                    <input
                      type="text"
                      id="nom"
                      name="nom"
                      value={formData.nom}
                      onChange={handleChange}
                      required
                      className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 dark:focus:ring-primary-600 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                    />
                  </div>

                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Email *
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 dark:focus:ring-primary-600 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="sujet" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Sujet *
                  </label>
                  <input
                    type="text"
                    id="sujet"
                    name="sujet"
                    value={formData.sujet}
                    onChange={handleChange}
                    required
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 dark:focus:ring-primary-600 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                  />
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Message *
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="6"
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 dark:focus:ring-primary-600 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                    placeholder="Décrivez votre demande en détail..."
                  ></textarea>
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-primary-800 dark:bg-primary-700 text-white py-3 px-4 rounded-lg font-semibold hover:bg-primary-700 dark:hover:bg-primary-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                  {loading ? (
                    <>
                      <i className="fas fa-spinner fa-spin mr-2"></i>
                      Envoi en cours...
                    </>
                  ) : (
                    'Envoyer le message'
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>

        {/* FAQ Section */}
        <div className="mt-16 bg-white dark:bg-gray-800 rounded-lg shadow-md p-8">
          <h2 className="text-2xl font-display font-bold text-gray-900 dark:text-primary-300 mb-8 text-center">
            Questions Fréquentes
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <h3 className="font-semibold text-gray-900 dark:text-gray-200 mb-2">Comment devenir artisan partenaire ?</h3>
              <p className="text-gray-600 dark:text-gray-400 mb-4">
                Inscrivez-vous gratuitement sur notre plateforme en remplissant le formulaire 
                d'inscription artisan. Votre profil sera vérifié sous 48h.
              </p>
            </div>

            <div>
              <h3 className="font-semibold text-gray-900 dark:text-gray-200 mb-2">Comment passer une commande ?</h3>
              <p className="text-gray-600 dark:text-gray-400 mb-4">
                Cliquez sur le bouton WhatsApp du produit qui vous intéresse. Un message 
                pré-rempli s'ouvrira pour contacter directement l'artisan.
              </p>
            </div>

            <div>
              <h3 className="font-semibold text-gray-900 dark:text-gray-200 mb-2">Les produits sont-ils authentiques ?</h3>
              <p className="text-gray-600 dark:text-gray-400 mb-4">
                Oui, tous nos artisans sont vérifiés et leurs produits sont 100% authentiques 
                et fabriqués selon les techniques traditionnelles.
              </p>
            </div>

            <div>
              <h3 className="font-semibold text-gray-900 dark:text-gray-200 mb-2">Livrez-vous à l'international ?</h3>
              <p className="text-gray-600 dark:text-gray-400 mb-4">
                La livraison dépend de chaque artisan. Contactez-les directement via WhatsApp 
                pour connaître leurs conditions de livraison.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;